import { useTranslation } from 'react-i18next';

import moment from 'moment';

import { I18NextNS } from 'src/models/Language.model';
import { ExamStatusEnum, Session } from 'src/models/Session.model';

const useGetExamGetPendingStatusText = () => {
  const { t } = useTranslation(I18NextNS.COMMON, {
    keyPrefix: 'examFields.examStatusEnum',
  });

  return (session: Session): string => {
    // Both files have been uploaded
    if (session.leftImageFile && session.rightImageFile) {
      return t(`${ExamStatusEnum.QUEUED}`);
    }

    const progressText =
      session.leftImageFile || session.rightImageFile ? '(1/2)' : '(0/2)';

    // Session was created less than 1 minute ago
    if (moment().diff(session.createdAt, 'seconds') < 60) {
      return t(`${ExamStatusEnum.UPLOADING}`) + ` ${progressText}`;
    }

    // Upload is incomplete and has exceeded 1 minute
    return t(`${ExamStatusEnum.UPLOAD_FAILED}`) + ` ${progressText}`;
  };
};

export default useGetExamGetPendingStatusText;
